export default __webpack_public_path__ + "static/media/product002.575c17ba.jpg";